import React, { createContext, useContext, useMemo } from 'react';
import { ANNOUNCEMENT_STATUS } from 'bs-unified-ui';

interface AnnouncementDetailContextType {
  announcementDetail: any;
  isArchived: boolean;
}

const AnnouncementDetailContext = createContext<AnnouncementDetailContextType | undefined>(undefined);

export const AnnouncementDetailProvider: React.FC<{
  children: React.ReactNode;
  announcementDetail: any;
}> = ({ children, announcementDetail }) => {
  const isArchived = announcementDetail?.status === ANNOUNCEMENT_STATUS.ARCHIVED;
  const value = useMemo(
    () => ({ announcementDetail, isArchived }),
    [announcementDetail, isArchived],
  );
  return (
    <AnnouncementDetailContext.Provider value={value}>
      {children}
    </AnnouncementDetailContext.Provider>
  );
};

export const useAnnouncementDetailContext = () => {
  const context = useContext(AnnouncementDetailContext);
  if (context === undefined) {
    throw new Error(
      'useAnnouncementDetailContext must be used within AnnouncementDetailProvider',
    );
  }
  return context;
};
